<template>
  <div id="bar" :style="size">
    <e-charts :size="size" style="top: 55px" :options="options"/>
  </div>
</template>

<script>
import ECharts from './ECharts'
import * as echarts from 'echarts';

export default {
  components: {
    ECharts
  },
  props: {
    varietyCoal: {  // 物资
      type: Object,
      default: () => ({})
    },
    numberCars: {   // 车数
      type: Object,
      default: () => ({})
    },
    netWeight: {   // 净重
      type: Object,
      default: () => ({})
    },
  },
  created() {
  },
  data: function () {
    return {
      year: 2000,
      options: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          textStyle: {
            color: 'white'
          },
        },
        xAxis: [
          {
            name: '物资',
            axisLine: {
              lineStyle: {
                color: 'white'
              },
            },
            axisTick: {       // y轴刻度线
              show: false
            },
            type: 'category',
            data: JSON.parse(JSON.stringify(this.varietyCoal)),
          }
        ],
        yAxis: [
          {
            name: '数量',
            axisLine: {
              lineStyle: {
                color: 'white'
              },
            },
            axisTick: {       // y轴刻度线
              show: false
            },
            splitLine: {
              show: true,  // 网格线
              lineStyle: {
                type: 'dashed'
              }
            },
            type: 'value'
          }
        ],
        series: [
          {
            itemStyle: {
              normal: {
                label: {
                  show: true, // 开启显示
                  position: 'top', // 在上方显示
                  textStyle: { // 数值样式
                    color: 'white',
                    fontSize: 12
                  }
                },
                color: new echarts.graphic.LinearGradient(
                  0, 1, 0, 0,
                  [
                    {offset: 0, color: '#00c6ff'},
                    {offset: 1, color: '#0072ff'}
                  ]
                )
              },
            },
            name: '车数',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
              focus: 'series'
            },
            data: JSON.parse(JSON.stringify(this.numberCars)),
          },
          {
            itemStyle: {
              normal: {
                label: {
                  show: true, // 开启显示
                  position: 'top', // 在上方显示
                  textStyle: { // 数值样式
                    color: 'white',
                    fontSize: 12
                  }
                },
                color: new echarts.graphic.LinearGradient(
                  0, 1, 0, 0,
                  [
                    {offset: 0, color: '#ee0979'},
                    {offset: 1, color: '#ff6a00'}
                  ]
                )
              }
            },
            name: '净重',
            type: 'bar',
            emphasis: {
              focus: 'series'
            },
            data: JSON.parse(JSON.stringify(this.netWeight)),
          },
        ]
      },
      size: {
        width: '100%',
        height: '375px'
      }
    }
  },
}
</script>

<style scoped>
</style>
